import {BooleanString, RadioYesNoField} from '@fo/shared-types';

const getBooleanFromString = (value?: string | boolean): boolean => {
  if (value && typeof value === 'string') {
    const lowercaseValue = value.toLowerCase();

    if (lowercaseValue === BooleanString.TRUE || lowercaseValue === RadioYesNoField.YES) {
      return true;
    }
    if (lowercaseValue === BooleanString.FALSE || lowercaseValue === RadioYesNoField.NO) {
      return false;
    }

    throw new TypeError(`Value is not a boolean: invalid value "${value}"`);
  }

  return !!value;
};

export default getBooleanFromString;
